<template>
    <div class="modal fade" id="dialogModal" tabindex="-1" aria-labelledby="dialogModalLabel" aria-hidden="false" ref="openDialogBtnRef">
    <div class="modal-dialog modal-md custom-modal-size  modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
        <div class="modal-header">
            <h1 class="modal-title fs-6" id="dialogModalLabel">{{ modalSetting.modalNm }}</h1>
        </div>
        <div class="modal-body" :style="{ maxHeight: 'calc(100vh - 150px)', overflowY: 'auto' }">
            <!-- <div class="table-responsive table-list table-pm">
      <DataTable  
          :value="gridOption.value"   
          editMode="cell" 
          @cell-edit-complete="onCellEditComplete"
          resizableColumns 
          scrollable
          scrollHeight="650px"
          columnResizeMode=""

      > <template #empty> <div class="center">데이터가 존재하지 않습니다.</div> </template>

      <Column 
        v-for="(col,index) of gridOption.columnList" 
        :key="index" 
        :field="col.field" 
        :header="col.header" 
        :style="[col.field === 'note' ? 'min-width:150px;' : col.style]"
      >
        <template  #body="{ data, field }" >
          <template v-if="field === 'agreeNo' || field === 'note'" >
              <div class="col_summary">{{ data[field] || '(수기입력)' }}</div>
          </template>

          <template v-else-if="field === 'vatplus' || field === 'vatminus' || field === 'taxamt'">
              <div class="col_summary" style="text-align: right;">
                <span :class="isNegative(data[field])">{{ numberFomat(data[field]) }}</span>
              </div>
          </template>

          <template v-else-if="field === 'reg_id' || field.includes('_yn')">
              <div class="col_summary" style="text-align: center;">{{ data[field] }}</div>
          </template>

          <template v-else>
            <div class="col_summary">{{ data[field] }}</div>
          </template>
        </template>


        <template #editor="{ data, field }">
          <template v-if="field === 'agreeNo' || field === 'note'" >
                <ElInput v-model="data[field]" autofocus />
          </template>

          <template v-else-if="field === 'vatplus' || field === 'vatminus' || field === 'taxamt'">
              <div class="col_summary" style="text-align: right;">
                <span :class="isNegative(data[field])">{{ numberFomat(data[field]) }}</span>
              </div>
          </template>
          
          <template v-else-if="field === 'reg_id' || field.includes('_yn')">
              <div class="col_summary" style="text-align: center;">{{ data[field] }}</div>
          </template>

          <template v-else>
            <div class="col_summary">{{ data[field] }}</div>
          </template>
        </template>

        
      </Column>
      </DataTable>
    </div> -->
            
            
            
            
            <div class="">
                <ElLabel name="">
                    <template #end>
                     <DatePicker
                    :selectDate="dialogValue.selectDate"
                    :max-date="dialogValue.nowDate ||  null"
                    @return="r=>dialogValue.selectDate = r"
                />
                </template>
              </ElLabel>
               
            </div>
        </div>
        <div class="modal-footer display">
            <Message severity="error" v-if="dialogValue.isText">값을 입력해주세요.</Message>
            <ElButton  type="modelFooterConfirm"  @buttonClick="confirm()">확인</ElButton>
            <ElButton  type="modelFooterConfirm"  @buttonClick="closeModal()">닫기</ElButton>
        </div>
        </div>
    </div>
    </div>

</template>
   
<script setup>
import {ref,onMounted, reactive,defineEmits, readonly} from 'vue'
import Message from 'primevue/message';
import common from '@/js/common';
import DatePicker from '@/components/common/DatePicker.vue'
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';

let dialog
const openDialogBtnRef = ref()
// Promise 객체를 핸들링하기 위한 ref
const resolvePromise = ref(null);

const modalSetting = ref({
    type : '',
    modalNm : '',
    msg : ''
})

const gridOption = ref({
  value : [],
  columnList : [
    { header: '영업기회 ID',      field: "sales_id"},
    { header: '영업기회명',       field: "sales_nm"},
    { header: '매입계산서발행일자',       field: "tax_sale_dt"},
    { header: '매입처',         field: "buy_cmp_info_nm"},
    { header: '총 지급액(VAT포함)',         field: "vatplus"},
    { header: '매입금액',         field: "vatminus" ,footer:true,style:{textAlign : 'right'}},
    { header: '부가세',   field: "taxamt" ,footer:true,style:{textAlign : 'right'}},
    { header: '영업대표',       field: "usr_nm",style:{textAlign : 'center'}},
    { header: '매출계산서 발행여부',       field: "tax_yn"},
    { header: '매출 수금여부',       field: "collect_yn"},
    { header: '매입계산서 발행여부',       field: "tax_sale_yn"},
    { header: '비고',       field: "note"},
  ],

})

const dialogValue = reactive({
    isText : false,
    inText : '',
    nowDate: null,
    selectDate:null
})


const emit = defineEmits(['updateValue','updateIndex']);

onMounted(()=>{
    dialog = new bootstrap.Modal(openDialogBtnRef.value,{
        keyboard: true
    });
    const today = new Date();
    const year = today.getFullYear();
    const month = ('0' + (today.getMonth() + 1)).slice(-2);
    const day = ('0' + today.getDate()).slice(-2);
    dialogValue.nowDate = `${year}-${month}-${day}`;
    dialogValue.selectDate = dialogValue.nowDate
})

//dialog open
function openDialog(type,msg,titleMsg){
    switch(type) {
        case 'view':
            modalSetting.value.type = 'alert'
            modalSetting.value.modalNm = titleMsg
            modalSetting.value.msg = msg
            break;
        case 'confirm':
            modalSetting.value.type = 'confirm'
            modalSetting.value.modalNm = titleMsg
            gridOption.value.value = msg
            break;
        case  'text':
            modalSetting.value.type = 'confirm'
            modalSetting.value.modalNm = titleMsg
            modalSetting.value.msg = msg
            break;
        default:
            modalSetting.value.type = 'dialog'
            modalSetting.value.modalNm = 'Dialog'
            modalSetting.value.msg = ''
            break;
    }
    dialog.show();
    // const {Promise,reject,resolve} = Promise.with
    return new Promise((resolve) => {
        resolvePromise.value = resolve;
    });
}
function numberFomat(num){
  //payment는 원단위임으로 소수점 노출 x
  num = isNaN(num) ? '0' :Number(num).toFixed(0)
  return common.checkNumberComma(num)
}

function onCellEditComplete(event){
  let { data, newValue, field } = event;
  data[field] = newValue
}


//모달창 닫기버튼 클릭
const cancel = ()=>{
    dialog.hide()
    emit('updateValue', dialogValue.inText);
    resolvePromise.value(false);
}

const checkvalue = () =>{
   return common.isEmpty(dialogValue.selectDate)
}

//모달창 확인버튼 클릭
const confirm = () => {
    
    if(!checkvalue()){
        emit('updateValue',dialogValue.selectDate);
        dialog.hide()
        resolvePromise.value(true);
    }else{
        dialogValue.isText = true
        setTimeout(() => {
            dialogValue.isText = false
        }, 2000);
    }
   
}

const closeModal = () =>{
    dialog.hide()
    resolvePromise.value(true);
}
function isNegative(data){
  if(!data) return
  data = data.toString().replaceAll('%','')

  if(Number(data) < 0){
    return 'text-b-rt'
  }
}

defineExpose({
    openDialog
})


</script>

<style>
.display {
    display: flex;
    align-items: center; /* 수직 정렬 */
    width: 100%; /* 부모 요소의 전체 너비 사용 */
}

.display > Message {
    flex-grow: 1; /* 남은 공간을 차지하여 왼쪽 끝으로 정렬 */
}

.display > ElButton {
    margin-left: auto; /* 오른쪽 끝으로 이동 */
}

.custom-modal-size {
  width: 600px; /* 원하는 너비 */
  max-width: 80%; /* 반응형 조정 */
  height: 500px; /* 원하는 높이 */
  max-height: 90%; /* 반응형 조정 */
}

.modal-content {
  height: 70%; /* 모달 내부 컨텐츠가 전체 높이를 차지하도록 설정 */
}
</style>
   